import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpsCallable } from 'firebase/functions';
import { AsyncThunkCreator } from '../../../index';
import { STATISTICS_REDUCER_NAME } from '../types';

export interface UsageStatsDocument {
  ocr: number;
  grading_podstawowa: number;
  egzamin_osmoklasisty: number;
  grading_rozszerzona: number;
  grading_dwujezyczna: number;
  answer_sheet: number;
  presentation: number;
  used_referral_checks: number;
  total: number;
  usedChecks: number;
  totalAvailableChecks: number;
}

export const fetchUsageStats = createAsyncThunk<
  UsageStatsDocument,
  void,
  AsyncThunkCreator<number>
>(
  `${STATISTICS_REDUCER_NAME}/fetchUsageStats`,
  async (_, { rejectWithValue, extra: { functions } }) => {
    try {
      const getUserUsageStats = httpsCallable(functions, 'users-getUserUsageStats');
      const result = await getUserUsageStats();
      return (result.data as any).body;
    } catch (e) {
      const error = e as any;
      return rejectWithValue(error.message);
    }
  }
);
